import React, {useState} from 'react';
import './Tile.scss'
// import ff from "../../public/img/icons/customeditor/Favorite_icon_empty.png"


export interface TileProps {
  id: number,
  name: string,
  isCategory: boolean,
  containsPatterns: boolean,
  url: string,
  thumbnail:string,
  isPatternImage:boolean,
  fetchPatterns: () => void,
  filter?:any,
  scaleFactor:number,
  uploadImage: (url: string, id: number, name:string, isPatternImage:boolean, scaleFactor:number) => void
}


export const Tile = React.forwardRef((props: TileProps, ref:any) => {

  const [isFavorite, setIsFavorite] = useState(false);
  const [isLoveFull, setIsLoveFull] = useState(false);

  return (
  <div ref={ref} className={props.isCategory?'e-card cat-card':'e-card'} data-image={!props.isCategory} data-is-img-lib={props.name === 'Master'}>
    <div className={props.isCategory?'e-card-image cat-card-image':'e-card-image'} onClick={()=>{
      if(props.isCategory){
        props.fetchPatterns()
      }else{
        props.uploadImage(props.url, props.id, props.name, props.isPatternImage, props.scaleFactor);
      }
    }}>
      <img src={props.thumbnail} />
      <div className={props.isCategory?'e-card-title cat-card-title':'e-card-title'}>{props.name}</div>
    </div>
    {/* {!props.isCategory?
    <div className='e-card-actions'>
      <button className={`e-card-btn ${isFavorite ? "tiles-img-fav-add" : "tiles-img-fav-remove"}`}
              title={`${isFavorite ? "Remove from Favorites":"Add to Favorites"}`}
              onClick={()=>{
                setIsFavorite(!isFavorite);
              }} />
      <button className="e-card-btn" title="Share">
        <img src='./img/icons/customeditor/Share.svg' className='tiles-img'/>
      </button>
      <button className={`e-card-btn ${isLoveFull ? "tiles-img-love-full" : "tiles-img-love-empty"}`}
              title={`${isLoveFull ? "Dislike" : "Like"}`}
              onClick={()=>{
                setIsLoveFull(!isLoveFull);
              }} />
      <button className="e-card-btn" title="Set Color">
        <img src='./img/icons/customeditor/SetColor.svg' className='tiles-img'/>
      </button>
    </div>
    :null} */}
  </div>
  )
})